"use client";

import Image from "next/image";
import { Button } from "../../shadcn/button";
import { Tooltip, TooltipContent, TooltipTrigger } from "../../shadcn/tooltip";
import { FloatingMenuItem } from "@/app/lib/features/floatingContent/floatingContent.types";
import { trackGeneric } from "@/app/lib/tracking/interactions";

interface WhatsAppButtonProps {
  item: FloatingMenuItem;
}

const WhatsAppButton = ({ item }: WhatsAppButtonProps) => {
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Button
          type="button"
          onClick={() => { trackGeneric("whatsapp"); window.open(item.url, "_blank", "noopener,noreferrer"); }}
          className="w-10 sm:w-11 lg:w-12 h-10 sm:h-11 lg:h-12 rounded-xl p-0 shadow-md"
          style={{ backgroundColor: "#25D366" }}
        >
          <Image src={item.icon} alt={item.title} width={24} height={24} className="object-contain" />
        </Button>
      </TooltipTrigger>
      {item.title && (
        <TooltipContent side="right">
          <p>{item.title}</p>
        </TooltipContent>
      )}
    </Tooltip>
  );
};

export default WhatsAppButton;